"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialsDocumentElement = void 0;
const react_1 = __importDefault(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_redux_1 = require("react-redux");
const lock_user_1 = __importDefault(require("../../lock_user"));
const update_single_element_thunk_1 = require("../../../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
const responsiveSize_1 = require("../../../../../../../helpers/responsiveSize");
const document_omponent_1 = require("./document_omponent");
const type = "Initials";
exports.InitialsDocumentElement = {
    type,
    sideBarComponent: SideBarComponent,
    documentComponent: document_omponent_1.DocumentComponent,
    propertiesComponent: () => react_1.default.createElement("div", null, "Properties Components"),
    construct: (_id, page) => {
        return {
            _id,
            type,
            page,
            scaling_mode: "custom",
            width: (0, responsiveSize_1.getResponsiveSize)(144, "width"),
            height: (0, responsiveSize_1.getResponsiveSize)(50, "height"),
            min_width: (0, responsiveSize_1.getResponsiveSize)(80, "width"),
            min_height: (0, responsiveSize_1.getResponsiveSize)(32, "height"),
            extra_attributes: {
                value: "",
                user: null,
                required: false,
                placeholder: "Initials",
                edit_type: "fillable",
                allow_free_hand: true,
                x: 0,
                y: 0,
            },
        };
    },
    sidebarBtnElement: {
        icon: pro_light_svg_icons_1.faT,
        label: "Initials",
    },
};
function SideBarComponent({ elementInstance }) {
    var _a, _b, _c;
    const { selectedDocument, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const dispatch = (0, react_redux_1.useDispatch)();
    const _element = (_a = selectedDocumentElements.find((x) => x._id === elementInstance._id)) !== null && _a !== void 0 ? _a : elementInstance;
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement(lock_user_1.default, { userProp: (_c = (_b = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _b === void 0 ? void 0 : _b.user) !== null && _c !== void 0 ? _c : null, onClick: (user) => {
                dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                    data: {
                        document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                        payload: Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, _element.extra_attributes), { user, user_id: user === null || user === void 0 ? void 0 : user._id, restricted: !!user }) }),
                    },
                }));
            } })));
}
